import React, { useEffect, useState } from 'react';
import checkIcon from '../../../images/Vectors/HappyHome_CheckIcon.svg';
import crossIcon from '../../../images/Vectors/HappyHome_CrossIcon.svg';
import LoadingSpinner from '../../../common/components/LoadingSpinner';

const WorkerProfileShiftsView = ({ profileId }) => {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchShifts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/worker-profile/${profileId}/shifts/get-all/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        if (response.ok) {
          const workerShifts = await response.json();
          setShifts(workerShifts);
        } else {
          console.error('Failed to fetch worker shifts:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching worker shifts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchShifts();
  }, [profileId]);

  const generateMatrix = () => {
    const matrix = [];
    const daysOfWeek = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
    const shiftsOfDay = ['Mañana', 'Tarde', 'Noche'];

    daysOfWeek.forEach(day => {
      const row = [];
      shiftsOfDay.forEach(shift => {
        const hasShift = shifts.some(s => s.day === day && s.shift === shift);
        row.push({ hasShift, activated: hasShift });
      });
      matrix.push(row);
    });
    return matrix;
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='profile-view-data-section'>
      <div className="profile-view-data-section shifts">
        <div className="profile-view-data-section-intro">
          <h2>Disponibilidad</h2>
        </div>
        <div className="calendar">
          <table className="availability">
            <thead>
              <tr>
                <th></th>
                {['Mañana', 'Tarde', 'Noche'].map((shift, index) => (
                  <th key={index}>{shift}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="space-row">{'\u00A0'}</tr>
              {['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'].map((day, dayIndex) => (
                <tr key={dayIndex}>
                  <td className="calendar-view-day">{day}</td>
                  {generateMatrix()[dayIndex].map((cell, cellIndex) => (
                    <td className="" key={cellIndex}>
                      <div className="update-calendar-row-cell">
                        <div className="update-calendar-row-icon">
                          {cell.hasShift ? (
                            <img src={checkIcon} alt="Check Icon" className="icon-svg" />
                          ) : (
                            <img src={crossIcon} alt="Cross Icon" className="icon-svg" />
                          )}
                        </div>
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WorkerProfileShiftsView;
